<template>
    <div>
        <p>Verwerk de geuploade camt bestanden en koppel de omschrijvingen + bedragen om facturen als betaald te markeren.</p>
        <br/>
        <a-button type="primary" @click="processCamt">Verwerk</a-button>
        <br/>
        <small>Let op: Dit kan even duren, afhankelijk van de hoeveelheid bestanden.</small>
        <br>
        <small>
            Wanneer een factuur op beschrijving gekoppeld word maar het bedrag afwijkt (wanneer de klant bijvoorbeeld iets teveel of te weinig betaald heeft)
            <br/>
            of als een prijs gekoppeld word maar de beschrijving niet (bijvoorbeeld als een klant vergeten is om de omschrijving mee te geven) laten we het zien onder het kopje "Handmatig Koppelen"
        </small>

    </div>
</template>

<script>

export default {
  computed: {
    user: {
      get: function () {
        return this.$store.state.user
      },
    },
  },
  methods: {
    processCamt() {
      this.$axios.post('/bookkeeping/camt/process', {}, {
        headers: {
          'Authorization': `Bearer ${this.user.user.token}`,
        },
      }).then(response => {
        // handle response
        console.log('Camt files processed successfully:', response.data)
      }).catch(error => {
        // handle error
        console.error('Error processing Camt files:', error)
      })
    },
  },
}
</script>
